import api from './api'
import { defActionSlice } from '../../../../helpers/defaultAction'
import { rePtmReducer } from './reducer'

const { 
    setLoading,
    setError,
    getPagedSuccess,
	getListSuccess,
	getTreeSuccess,
    createSuccess,
    saveSuccess,
	getPtmByIdsSuccess,
    clear
} = rePtmReducer.actions

export const getPtmSecondLevel = (values) => {
	const defObj = {
		req: setLoading,
        suc: getPtmByIdsSuccess,
        fail: setError,
		service   : {
			func   : api.getPtmSecond,
			params : values
		}
	}
	return defActionSlice(defObj)
}

export const getPtmByIds = (values) => {
	const defObj = {
		req: setLoading,
        suc: getPtmByIdsSuccess,
        fail: setError,
		service   : {
			func   : api.getPtmByIds,
			params : values
		}
	}
	return defActionSlice(defObj)
}

export const getTreeAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getTreeSuccess,
        fail: setError,
        service: {
            func: api.getTree,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getListAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getListSuccess,
        fail: setError,
        service: {
            func: api.getList,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getPagedAllAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagedSuccess,
        fail: setError,
        service: {
            func: api.getPagedAll,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getPagedAuditAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagedSuccess,
        fail: setError,
        service: {
            func: api.getPagedAudit,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const deleteAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.delete,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const restoreAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.restore,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const createAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: createSuccess,
        fail: setError,
        service: {
            func: api.create,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const updateAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.update,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const clearAction = () => {
    const defObj = {
        req: clear,
    }
    return defActionSlice(defObj)
}